import { Box, Container, Grid } from "@mui/material";
import React from "react";

import { AccountInfo } from "components/account/AccountInfo";
import { AccountSubHeader } from "components/account/AccountSubHeader";
import { MeteringInfo } from "components/account/MeteringInfo";
import { ServicePlan } from "components/account/ServicePlan";
import { Typography } from "new-components/typography/Typography";
import { UserProps } from "types/users";

export enum LabelType {
  FULL_LABELING = "Groundlight’s standard labeling resources AND user-provided labeling resources.",
  ONLY_USER_PROVIDED_LABELING = "User-provided labelers only",
}

// These components help to add styles to the account summary page
export function AccountSectionTitle(props: { text: string }) {
  const { text } = props;
  return (
    <Box sx={{ width: "100%", borderBottom: "1px solid #49494D", py: "13px" }}>
      <Typography sx={{ fontSize: "24px", lineHeight: "24px", textAlign: "center" }}>{text}</Typography>
    </Box>
  );
}

// Main component for the account summary page
export function AccountPage(props: UserProps) {
  const { user } = props;

  return (
    <Box id="account-page" className="h-[calc(100%-50px)]">
      <AccountSubHeader user={user} />
      <Container
        maxWidth="md"
        sx={{
          marginBottom: "40px",
          px: { xs: "10px", sm: "20px", md: "30px" },
        }}
      >
        <Grid container spacing="20px" mt={0}>
          <Grid item xs={12} sm={6} md={6}>
            <AccountInfo user={user} />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <ServicePlan />
          </Grid>
          <Grid item xs={12}>
            <MeteringInfo />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
